import Record from "./base"

export default class Lesson extends Record {
  constructor(...args) {
    super(...args)
    const [model, props] = args
  }
}
